<ng-template #fullyLoaded>
  <router-outlet></router-outlet>
  <app-toast></app-toast>

  <app-custom-modal style="text-align: center" [showModal]="modalState">
    <ng-container body>
      <div class="ok-body">
        <p><strong>You will be signed out after</strong></p>
        <div class="informationCard-progress" [style.--information-card-progress]="(timerRemaining / 30) * 100">
          <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 106 106" width="106px" width="106px">
            <linearGradient id="a" x1="36.499" x2="68.128" y1="74.019" y2="33.519" gradientTransform="matrix(1 0 0 -1 0 105.89)" gradientUnits="userSpaceOnUse">
              <stop offset="0" style="stop-color: #7f6eb1; stop-opacity: 0" />
              <stop offset=".514" style="stop-color: #806fb2; stop-opacity: 0.58" />
              <stop offset="1" style="stop-color: #7e6db0; stop-opacity: 0" />
            </linearGradient>
            <circle class="progressCircle-inner" cx="53" cy="53" r="25.5" fill="none" stroke="url(#a)" stroke-width="3" />
            <linearGradient id="b" x1="40.491" x2="66.81" y1="7.059" y2="103.485" gradientTransform="matrix(1 0 0 -1 0 105.89)" gradientUnits="userSpaceOnUse">
              <stop offset="0" style="stop-color: #94c93d" />
              <stop offset="1" style="stop-color: #65bc47" />
            </linearGradient>
            <circle class="progressCircle-outer" cx="53" cy="53" r="38" fill="none" stroke="url(#b)"
              stroke-width="16" />
            <linearGradient id="c" x1="85.939" x2="11.994" y1="13.968" y2="101.342" gradientTransform="matrix(1 0 0 -1 0 105.89)" gradientUnits="userSpaceOnUse">
              <stop offset="0" style="stop-color: #a394d0" />
              <stop offset="1" style="stop-color: #806fb2" />
            </linearGradient>
            <circle class="progressCircle-progress" cx="53" cy="53" r="41.5" fill="none" stroke="url(#c)" stroke-width="23" />
          </svg>
          <span>
            {{ timerRemaining }}
          </span>
        </div>
      </div>
    </ng-container>
  </app-custom-modal>
</ng-template>
<div *ngIf="initialLoad; else fullyLoaded" class="initialLoad">
  <img src="assets/images/new/loading.webp" fetchPriority="high" alt="checking civil id" style="max-width:300px; max-height: 300px;" />
</div>